export const FETCH_PRODUCT_PRICE_UPDATES = 'FETCH_PRODUCT_PRICE_UPDATES';
export const CLEAR_PRODUCT_PRICES = 'CLEAR_PRODUCT_PRICES';
export const PRODUCT_PRICE_RETAIN_STATE = 'PRODUCT_PRICE_RETAIN_STATE';
export const PRODUCT_PRICE_SET_PAGE_SIZE = 'PRODUCT_PRICE_SET_PAGE_SIZE';
export const PRODUCT_PRICE_SET_PAGE_NO = 'PRODUCT_PRICE_SET_PAGE_NO';
export const PRODUCT_PRICE_SET_SORT_PARAMS = 'PRODUCT_PRICE_SET_SORT_PARAMS';
export const FETCH_PRICE_UPDATE_PROGRESS = 'FETCH_PRICE_UPDATE_PROGRESS';
export const SET_PRICE_UPDATE_PROGRESS_VIEW = 'SET_PRICE_UPDATE_PROGRESS_VIEW';
export const SET_PRICE_UPDATE_LOADING_VIEW = 'SET_PRICE_UPDATE_LOADING_VIEW';
